import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

// Row action buttons (edit / delete / view) used in every table's Action
// column. Style them here and every table follows.

const KINDS = {
  edit: { Icon: EditOutlinedIcon, label: 'Edit', tone: 'navy' },
  delete: { Icon: DeleteOutlineRoundedIcon, label: 'Delete', tone: 'danger' },
  view: { Icon: VisibilityOutlinedIcon, label: 'View', tone: 'accent' },
};

const TONES = {
  navy: { color: '#3D4977', hover: 'rgba(61, 73, 119, 0.10)', ring: 'rgba(61, 73, 119, 0.25)' },
  danger: { color: '#D92D20', hover: 'rgba(240, 68, 56, 0.10)', ring: 'rgba(240, 68, 56, 0.25)' },
  accent: { color: '#2F6BEA', hover: 'rgba(69, 130, 255, 0.12)', ring: 'rgba(69, 130, 255, 0.28)' },
};

const toneStyle = ({ color, hover, ring }) => ({
  color,
  '&:hover': { backgroundColor: hover },
  '&.Mui-focusVisible': { boxShadow: `0 0 0 3px ${ring}` },
});

const useStyles = makeStyles({
  row: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    whiteSpace: 'nowrap',
  },
  button: {
    width: 32,
    height: 32,
    padding: 0,
    borderRadius: 8,
    transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
    '& svg': { fontSize: 20 },
    '&.Mui-disabled': { opacity: 0.35 },
  },
  navy: toneStyle(TONES.navy),
  danger: toneStyle(TONES.danger),
  accent: toneStyle(TONES.accent),
});

// Keeps a row's action buttons on one line.
export function RowActions({ children }) {
  const classes = useStyles();
  return <span className={classes.row}>{children}</span>;
}

export function RowAction({
  kind = 'edit', label, onClick, disabled,
}) {
  const classes = useStyles();
  const { Icon, label: defaultLabel, tone } = KINDS[kind] || KINDS.edit;
  const title = label || defaultLabel;
  const button = (
    <IconButton
      aria-label={title}
      className={`bez-row-action ${classes.button} ${classes[tone]}`}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon />
    </IconButton>
  );
  // A disabled button fires no mouse events, so the tooltip needs a wrapper.
  return (
    <Tooltip title={title} arrow>
      {disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
}
